module.exports = __webpack_public_path__ + "img/location.d5034b87.png";